<rid-categorise-yes-no
  class="h-dvh"
  [questions]="[
    {
      id: 'q1',
      question: 'Bevat dit woord een dubbelzetter?',
      options: [{ type: 'WORD', word: 'stoel' }],
      answer: 'NO',
    },
  ]"
  (finished)="$router.navigate(['/mechanics/sorting/yes-or-no'])"
/>
